module.exports = __webpack_public_path__ + "static/media/logo-joyeria.46c93849.png";